export default __webpack_public_path__ + "static/media/project3.9f33f78f.jpg";